import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import { onMobileNavToggle } from "redux/actions/Theme";
import './MenuContent.css';


const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey}/> : localeKey.toString();

const SideNavContent = (props) => {
	const { sideNavTheme, hideGroupTitle, localization } = props;
  const {pathname} = useLocation();

  const [chosen, setChosen] = useState("");
  useEffect(() => {
    setChosen(window.location.href);
  }, [pathname]);

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0, backgroundColor: "transparent", lineHeight: "140%", border:"none"}}
        // defaultSelectedKeys={[routeInfo?.key]}
        // defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={(hideGroupTitle ? "hide-group-title" : "") + "menu-site"}
    >
      {navigationConfig.map((menu) =><div key={menu.key}>
        <Link to={menu.path} className={''}>
          <div onClick={() => setChosen(menu.path)} className={(chosen.includes(menu.path)?"mainButton":"")+"  menuButtons"}>
            <span>{setLocale(localization, menu?.key)}</span>
          </div>
        </Link>
      </div>
      )}
    </Menu>
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor, locale } = theme;
  return { sideNavTheme, topNavColor, localization: locale };
};

export default connect(mapStateToProps, { onMobileNavToggle })(SideNavContent);
